import ConfigParameter, { gettext } from "../ConfigParameter";

export default class FormContent extends ConfigParameter {

    constructor() {
        super('content', 'hidden', null, null, [{
            type: 'formEmail',
            group: 'form',
            config: {
                key: 'email',
                label: 'Email',
                placeholder: gettext('E-mail'),
                required: true,
                inline: false
            }
        }, {
            type: 'formCaptcha',
            group: 'form',
            config: {
                inline: false,
                key: 'captcha',
                label: '',
                placeholder: ''
            }
        }, {
            type: 'formSubmit',
            group: 'form',
            config: {
                key: 'submit',
                label: gettext('Submit'),
                inline: false,
                submitButtonBackgroundColor: '#2dacd1',
                submitButtonBorderColor: '#2dacd1',
                submitButtonTextColor: '#ffffff',
                placeholder: ''
            }
        }]);
    }

}


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigParameters/FormContent.js